/**
 * @module @yimoka/i18n/remote/apply-bundle
 * @summary 将远程 bundle 写入 i18next
 * @author keep
 * @since 2026-05-19
 */

import { isVacuous } from '@yimoka/shared';
import type { i18n } from 'i18next';

import { resolveNamespaceWithFallback } from '../bundled/merge';
import type { BundledRegistry } from '../bundled/registry';

/**
 * 将整包 namespace 合并后写入 i18next。
 *
 * @param i18nInstance - i18next 实例
 * @param lang - 语种短码
 * @param bundle - namespace → 文案
 * @param registry - bundled 注册表
 */
export function applyBundleToI18n(
  i18nInstance: i18n,
  lang: string,
  bundle: Record<string, unknown>,
  registry: BundledRegistry,
): void {
  for (const [ns, data] of Object.entries(bundle)) {
    if (!isVacuous(data) && typeof data === 'object' && !Array.isArray(data)) {
      const merged = resolveNamespaceWithFallback(
        registry,
        lang,
        ns,
        data as Record<string, unknown>,
      );
      i18nInstance.addResourceBundle(lang, ns, merged, true, true);
    }
  }
}
